import React from "react"
import PropTypes from "prop-types"
import { useOutletContext } from "react-router-dom"
import { QuestionCircleOutlined } from "@ant-design/icons"
import { Space, Tooltip, Typography } from "antd"

import ListInput from "@components/Form/Input/ListInput"
import { FormShape } from "@components/Form"
import { TIER_NAMES } from "@components/Domain"
import { TYPE_STRING, TYPE_CHECKBOX, TYPE_NUMBER, TYPE_TEXT } from "@components/Form/FormItem/types"

import "./TiersListInput.css"

const LABEL_NAME = "Name"
const LABEL_INTERNAL = "Internal"
const LABEL_DESCRIPTION = "Description"
const LABEL_INTERNAL_TOOLTIP = "Internal classes are not visible to investors in the soft commitment form."


const TiersListInput = ({
  form,
  name,
  path,
  title,
  addTitle
}) => {
  const { isOrganizationController } = useOutletContext()

  const max = TIER_NAMES.length
  const onlyLastDelete = true

  const canEditReturnPercentage = isOrganizationController()

  const schema = [
    {
      name: "title",
      type: TYPE_STRING,
      required: true,
      maxLength: 64,
      itemProps: { noStyle: true },
      inputProps: {
        style: { width: "25%" },
        prefix: (
          <Typography.Text type="secondary">
            <span className="enum" />
          </Typography.Text>
        )
      },
      placeholder: LABEL_NAME,
    },
    {
      name: "returnPercentage",
      type: TYPE_NUMBER,
      itemProps: { noStyle: true },
      inputProps: {
        style: { width: "12%" },
        parser: (value) => value?.replace('%', ''),
        formatter: (value) => `${value}%`,
        min: "0",
        step: "0.1",
        disabled: !canEditReturnPercentage,
      },
    },
    {
      name: "description",
      type: TYPE_TEXT,
      required: true,
      maxLength: 256,
      itemProps: { noStyle: true },
      inputProps: { style: { width: "63%" }, autoSize: { minRows: 1 } },
      placeholder: LABEL_DESCRIPTION,
    },
    {
      name: "isPrivate",
      type: TYPE_CHECKBOX,
      required: false,
      itemProps: { noStyle: true },
      inputProps: {
        style: { marginTop: 6 },
        label: (
          <Space>
            {LABEL_INTERNAL}
            <Tooltip title={LABEL_INTERNAL_TOOLTIP}>
              <Typography.Text type="secondary">
                <QuestionCircleOutlined />
              </Typography.Text>
            </Tooltip>
          </Space>
        ),
      }
    }
  ]

  const listInputProps = {
    min: 1,
    className: "horizontal-oriented",
    max,
    form,
    name,
    path,
    title,
    schema,
    addTitle,
    onlyLastDelete
  }

  return (
    <div className="tiers-list-input" style={{ marginBottom: 24 }}>
      <ListInput {...listInputProps} />
    </div>
  )
}

TiersListInput.propTypes = {
  form: FormShape.isRequired,
  name: PropTypes.arrayOf(PropTypes.string).isRequired,
  path: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  addTitle: PropTypes.string.isRequired,
}

export default TiersListInput
